import { testMsg } from "../../test-apis";
import { isTestCompany } from "../../utils/auth";
import http from "../../utils/http";
import { toast } from "../../utils/toast";



//금융정보 수집 인증 데이터 조회
export const getTaxAccountantFinancesAccounts = (orgCd) => {
  return new Promise((resolve, reject) => {
    http
      .get("/finances/tax-accountant/accounts", {
        params: {
          orgCd,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 인증 정보 등록
export const postTaxAccountantFinancesAuth = (body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .post("/finances/tax-accountant/auth", body)
      .then((res) => {
        toast.success("인증되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 인증정보 변경
export const modifyTaxAccountantFinancesAccounts = (financeAccountIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .put(`/finances/tax-accountant/accounts/${financeAccountIdx}`, body)
      .then((res) => {
        toast.success("인증 정보를 변경했습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 인증정보 변경
export const scrapingTaxpayerFromHometax = () => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .post(`/finances/tax-accountant/scraping-taxpayers-from-hometax`)
      .then((res) => {
        toast.success("수임처 불러오기에 성공했습니다.");
        resolve(res);
      })
      .catch((err) => {
        toast.error("수임처 불러오기에 실패했습니다.");
        reject(err);
      });
  });
};
// 인증정보 변경
export const scrapingTaxpayerDetailFromHometax = (bsno) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .post(`/finances/tax-accountant/scraping-taxpayer-detail-from-hometax/${bsno}`)
      .then((res) => {
        toast.success("수임처 불러오기에 성공했습니다.");
        resolve(res.data);
      })
      .catch((err) => {
        toast.error("수임처 불러오기에 실패했습니다.");
        reject(err);
      });
  });
};